<template>
<div v-loading="loading">
  <div class="op">
<div class="nam">
  <el-input v-model="name" style="margin-left:10px" clearable size="mini" placeholder="请输入键"></el-input>
</div>
<el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px;margin-right:10px" icon="el-icon-search" @click="serch">搜索</el-button>
<span style="color:#265D0A">共计{{allcount}}条</span>

</div>
  <el-table
    :default-sort = "{prop: 'expire', order: 'descending'}"
    :data="tableData"
    style="width: 100%"
    stripe>
    <el-table-column
      prop="key"
      label="键"
      >
    </el-table-column>
    <el-table-column
      prop="value"
      label="值"
     >
    </el-table-column>
      <el-table-column
      prop="expire"
       sortable
      label="缓存时间(秒)">
    </el-table-column>
<el-table-column

     label="操作">
      <template slot-scope="scope">
        <el-button
        type="primary"
          size="mini"
          icon="el-icon-s-check"
          @click="handle(scope.$index, scope.row)">编辑</el-button>
           <el-button
        type="warning"
          size="mini"
          icon="el-icon-delete-solid"
          @click="del(scope.$index, scope.row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-button
        style="margin:20px;float:right"
        type="primary"
        size="mini"
        icon="el-icon-upload2"
        @click="toexcel()">导出</el-button>
 <el-dialog title="修改redis" :visible.sync="dialogFormVisible">
  <el-form :model="form">
      <el-form-item label="键" :label-width="fitwidth" >
      <el-input v-model="form.key" readonly size="mini" style="width:250px" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="值" :label-width="fitwidth" >
      <el-input v-model="form.value" size="mini" style="width:250px" autocomplete="off"></el-input>
    </el-form-item>
     <el-form-item label="时间(秒)"  :label-width="fitwidth" >
      <el-input v-model="form.expire" size="mini" style="width:250px"></el-input>
    </el-form-item>
  </el-form>

  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="confim">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>

<style>
.op{
  display: flex;
  align-items: center;

}
  .idc{
    width: 200px
  }
  .nam{
    margin-right: 20px
  }
  .ywtyoe{
    width: 200px;
    margin-left: 20px
  }
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .pone{
    margin-top: 40px
  }
  .el-timeline{
    padding-left: 20px
  }
  .add{
      margin-left: 20px
  }
</style>

<script>
import trimupcase from "../../utils/trimupcase"
import Axios from "axios"
import Cookies from "js-cookie";
 import CryptoJS from 'crypto-js'
 import { Loading } from 'element-ui';
 import {listtown} from '../../utils/address'
import {baseUrl2} from "../../utils/global"
import defaultImg from "../../assets/defaultPicture.jpg"
import Candode from "../Core/candode"
import {decryptByDES,decrypt} from '../../utils/cypto'
import {formatDate} from '../../utils/datetime'
import {getType} from "../../utils/typeAuth"
import baseUrl from "../../utils/global"
  export default {
    components:{
      Candode
    },
       data() {

      return {
        allcount:0,
        fitwidth:"100px",
        list:[],
        dialogFormVisible:false,
         name:"",
        tableData: [],
        form:{
            value:'',
            expire:'',
            key:''
        },
        loading:false,
        flag:true
      }
    },
    methods: {
      handle(s,d){
          console.log(d)
        this.dialogFormVisible=true
        this.form.key=d.key
        this.form.expire=d.expire
        this.form.value=d.value
      },
      //shanchu
      del(s,d){
          let data={
              key:d.key
          }
          this.$api.getlist.redisdelete(data).then((res) => {
               if(res.code==200){
                this.$message({
                    type:"success",
                    message:res.message
                })
                this.serch()
            }else{
                 this.$message({
                    type:"warning",
                    message:res.message
                })
            }

        }).catch((res) => {

        });
      },

      //搜索
      serch(){
      this.loading=true
     let data={
      key:this.name
     }
     this.$api.getlist.getInfos(data).then((res) => {
        if(res.code==200){
          this.loading=false
          this.tableData=res.data
          this.allcount=res.data.length
        }else{
          this.loading=false
          this.$message(res.message)
        }
        }).catch((res) => {
          this.loading=false
        });
      },
      toexcel(){
          this.loading=true
          let data={
                key:this.name
            }
           this.$api.getlist.redisexport(data).then((res) => {

      if(res.code==200){
				this.loading=false
						window.location.href=baseUrl.baseUrl+"/download/excel?fileName="+res.data
					}else{
            this.loading=false
            this.$message(res.message)
          }

        }).catch((res) => {
             //this.$message("导出失败")
          	this.loading=false
        });

      },
     confim(){
 this.$api.getlist.redisupdate(this.form).then((res) => {
            if(res.code==200){
                this.$message({
                    type:"success",
                    message:res.message
                })
                this.dialogFormVisible=false
                this.serch()
            }else{
                 this.$message({
                    type:"warning",
                    message:res.message
                })
            }



        }).catch((res) => {

        });
     },
      handleChange(){
      },
      torz(){

      },
        handleDelete(g,h){

        },


    },

    created(){


    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Myvue/redis.vue